import React from 'react';
import { Star as LucideStar } from 'lucide-react';

interface StarProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Star: React.FC<StarProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideStar width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Star;
